/// <amd-module name="SuiteCommerce.TestimonialsCCT.View"/>
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
define("SuiteCommerce.TestimonialsCCT.View", ["require", "exports", "jQuery", "CustomContentType.Base.View", "SuiteCommerce.Testimonials.Utils", "SuiteCommerce.TestimonialsCCT.Model", "netsuite_testimonialscct_vertical.tpl", "netsuite_testimonialscct_horizontal.tpl", "SuiteCommerce.Testimonials.TestimonialsCCT.Configuration", "SuiteCommerce.Testimonials.Instrumentation", "BxSlider"], function (require, exports, jQuery, CustomContentTypeBaseView, Utils_1, TestimonialsCCT_Model_1, verticalTemplate, horizontalTemplate, TestimonialsCCT_Configuration_1, Instrumentation_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var TestimonialsCCTView = /** @class */ (function (_super) {
        __extends(TestimonialsCCTView, _super);
        function TestimonialsCCTView(options) {
            var _this = _super.call(this, options) || this;
            _this.template = horizontalTemplate;
            _this.VERTICAL = '2';
            _this.SQUARE = '2';
            _this.container = options.container;
            _this.model = new TestimonialsCCT_Model_1.TestimonialsCCTModel();
            _this.instanceId = options.instanceId;
            _this.setupListeners();
            return _this;
        }
        TestimonialsCCTView.prototype.setupListeners = function () {
            var _this = this;
            var isRunningSeo = this.container.getComponent('Environment').isPageGenerator();
            this.on('afterViewRender', function () {
                if (_this.model.testimonials.size() > 1 && !isRunningSeo && _this.model.orientation !== _this.VERTICAL) {
                    setTimeout(function () {
                        _this.$("#testimonial-slider-" + _this.instanceId).bxSliderNew({
                            nextText: (Utils_1.Utils.isPhoneDevice() ? '' : '<a class="testimonial-next-icon"></a>'),
                            prevText: (Utils_1.Utils.isPhoneDevice() ? '' : '<a class="testimonial-prev-icon"></a>'),
                            touchEnabled: true,
                            auto: true,
                            pager: true,
                        });
                    }, 10);
                }
            });
            this.model.testimonials.on('reset', function () {
                _this.render();
            });
        };
        TestimonialsCCTView.prototype.install = function (settings, contextData) {
            _super.prototype.install.call(this, settings, contextData);
            this.parseSettings(settings);
            if (this.model.testimonials.size() > 0) {
                this.logQuantityOfTestimonialsUsed();
                this.logLayoutUseBxSlider();
            }
            return jQuery.Deferred().resolve();
        };
        TestimonialsCCTView.prototype.logQuantityOfTestimonialsUsed = function () {
            var quantityOfTestimonialsLog = Instrumentation_1.default.getLog('quantityOfTestimonialsLog');
            quantityOfTestimonialsLog.setParameters({
                activity: 'Quantity of Testimonials used',
                instanceCount: this.model.testimonials.size(),
            });
            quantityOfTestimonialsLog.submit();
        };
        TestimonialsCCTView.prototype.logLayoutUseBxSlider = function () {
            this.model.orientation !== this.VERTICAL
                ? this.logUsageOfTheLayoutWithBxSlider()
                : this.logUsageOfTheLayoutWithoutBxSlider();
        };
        TestimonialsCCTView.prototype.logUsageOfTheLayoutWithBxSlider = function () {
            var usageWithBxSliderLog = Instrumentation_1.default.getLog('usageWithBxSliderLog');
            usageWithBxSliderLog.setParameters({
                activity: 'Usage of the layout with BxSlider',
            });
            usageWithBxSliderLog.submit();
        };
        TestimonialsCCTView.prototype.logUsageOfTheLayoutWithoutBxSlider = function () {
            var usageWithoutBxSliderLog = Instrumentation_1.default.getLog('usageWithoutBxSliderLog');
            usageWithoutBxSliderLog.setParameters({
                activity: 'Usage of the layout without BxSlider',
            });
            usageWithoutBxSliderLog.submit();
        };
        TestimonialsCCTView.prototype.update = function (settings) {
            _super.prototype.update.call(this, settings);
            this.parseSettings(settings);
            return jQuery.Deferred().resolve();
        };
        TestimonialsCCTView.prototype.parseSettings = function (settings) {
            this.model.addProperties(settings);
        };
        TestimonialsCCTView.prototype.validateContextDataRequest = function () {
            return true;
        };
        TestimonialsCCTView.prototype.getContext = function () {
            this.selectTemplate();
            var selectedLinkOption = TestimonialsCCT_Configuration_1.CCTConfiguration.getLinkByOption(this.model.linkOption);
            return {
                cctInstanceId: this.instanceId,
                headerName: this.model.header,
                imageStyle: this.model.imageStyle !== this.SQUARE ? 'img-circle' : '',
                testimonials: this.model.testimonials.models,
                textColor: TestimonialsCCT_Configuration_1.CCTConfiguration.getColorByOption(this.model.fontColor),
                target: this.model.openInNewWindow === 'T' ? '_blank' : '_self',
                linkArea: {
                    isTitle: selectedLinkOption === TestimonialsCCT_Configuration_1.LinkOptions.title,
                    isSubtitle: selectedLinkOption === TestimonialsCCT_Configuration_1.LinkOptions.subtitle,
                    isImage: selectedLinkOption === TestimonialsCCT_Configuration_1.LinkOptions.image,
                    isEntireArea: selectedLinkOption === TestimonialsCCT_Configuration_1.LinkOptions.entireArea,
                },
            };
        };
        TestimonialsCCTView.prototype.selectTemplate = function () {
            if (this.model.orientation === this.VERTICAL && Utils_1.Utils.isDesktopDevice()) {
                this.template = verticalTemplate;
            }
            else {
                this.template = horizontalTemplate;
            }
        };
        return TestimonialsCCTView;
    }(CustomContentTypeBaseView));
    exports.TestimonialsCCTView = TestimonialsCCTView;
});
